import { useEffect, useRef, useState } from "react";
import { formatINR } from "@/lib/brand";

/**
 * Animated count-up display for a currency figure.
 * Renders in ledger (mono, tabular) style.
 */
export default function LedgerNumber({ value, prefix = "", suffix = "", duration = 700, className = "", testId }) {
  const [display, setDisplay] = useState(value);
  const rafRef = useRef(null);
  const fromRef = useRef(value);
  const startRef = useRef(null);

  useEffect(() => {
    fromRef.current = display;
    startRef.current = null;
    const target = value;
    const from = fromRef.current;
    if (from === target) return;
    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const t = Math.min(1, (ts - startRef.current) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const next = from + (target - from) * eased;
      setDisplay(next);
      if (t < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const formatted = prefix ? `${prefix}${formatINR(display).replace("₹", "")}` : formatINR(display);
  return (
    <span className={`num ${className}`} data-testid={testId}>
      {formatted}
      {suffix}
    </span>
  );
}
